// common
export const GET_REQUEST = 'appointmentNotes/GET_REQUEST'
export const GET_SUCCESS = 'appointmentNotes/GET_SUCCESS'
export const GET_FAILURE = 'appointmentNotes/GET_FAILURE'

export const UPDATE_NOTES = 'appointmentNotes/UPDATE_NOTES'